import { render, staticRenderFns } from "./close-icon.vue?vue&type=template&id=132850b8&scoped=true&"
import script from "./close-icon.vue?vue&type=script&lang=js&"
export * from "./close-icon.vue?vue&type=script&lang=js&"
import style0 from "./close-icon.vue?vue&type=style&index=0&id=132850b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "132850b8",
  null
  
)

export default component.exports